import { STORAGE_URL } from '@/shared/config/app-config';

/**
 * Build the full URL for a storage asset (photos, avatars, etc.)
 */
export function getStorageUrl(path: string | undefined | null): string | undefined {
  if (!path) return undefined;

  // Default avatars are served locally from /avatars/
  if (path.startsWith('avatar_')) {
    return `/avatars/${path}`;
  }

  // Uploaded photos are served from Minio/S3
  return `${STORAGE_URL}${path}`;
}
